import { ModalProps } from '../models';
import { ReactComponent as DeleteIcon } from '../../../images/nde-icon-delete.svg';
import './FAQModal.scss';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import { selectControls } from '../../../redux/controls';



export const FAQModal = ({ open, onClose }: ModalProps): JSX.Element => {
  const controls = useSelector(selectControls);

  return (
    <>
      {
        open &&
        <ReactModal
          isOpen={open}
          className="nqt-modal nqt-sys-req-modal"
          overlayClassName="nqt-modal-overlay"
          shouldFocusAfterRender={true}
          shouldReturnFocusAfterClose={true}
          contentLabel={controls?.FooterFAQ?.controlText}
        >
          <div className='nqt-modal--container'>
            <div className='nqt-modal--header-group'>
              <header className='nqt-modal--title'>{controls?.FooterFAQ?.controlText}</header>
              <button className='nqt-modal--close-button'
                ref={(el) => el?.focus()}
                onClick={() => onClose(false)}>
                <DeleteIcon />
                <span className="visually-hidden">{controls?.ModalClose?.controlText}</span>
              </button>
            </div>
            <div className="nqt-modal--border">
              <section className="nqt-modal--content">
                <span className="title_sm">About the National Assessment of Educational Progress (NAEP)  :</span>
              </section>
            </div>
          </div>
        </ReactModal>
      }
    </>
  );
};

export default FAQModal;